
import accountRoutes from './routes/private/account.js'
import authRequiredRoutes from './routes/public/authrequired.js'
import mainRoutes from './routes/public/main.js' //Add this last so we get the not found url at the end
export default accountRoutes.concat(authRequiredRoutes).concat(mainRoutes)
